import React from 'react';
import { useParams } from 'react-router-dom';
import { useDocument } from 'react-firebase-hooks/firestore';
import { Avatar, Divider, Button } from 'antd';
import { PhoneOutlined, MailOutlined } from '@ant-design/icons';
import { useUserWithRole } from 'hooks/custom-auth';
import Client from 'containers/app/client';
import { LayoutPage } from 'components/layouts';
import LoadingFullPage from 'components/loading-full-page';
import { getLabel } from 'utils/labels';
import { orgTypes, sectors } from 'utils/roles-sectors';

import './style.css';
import RatingAverage from 'components/rating-average';

const EmployerDetail = () => {
  const { id } = useParams();
  const [user, loadingUser, errorUser] = useUserWithRole(Client.auth);

  const connectionRef = Client.db
    .collection('worker_connection')
    .where('worker', '==', Client.currentUserId())
    .where('userId', '==', id);

  const ref = Client.db.doc(`users/${id}`);
  const [doc, loading, error] = useDocument(ref);
  const [connection, connectionLoading, connectionError] = useDocument(
    connectionRef
  );

  const [docOrg, loadingOrg, errorOrg] = useDocument(
    doc &&
      doc.data().organization &&
      Client.dbDoc(`organizations/${doc.data().organization}`)
  );

  if (
    loading ||
    loadingUser ||
    connectionLoading ||
    loadingOrg
  )
    return <LoadingFullPage />;
  if (error) throw error;
  if (errorOrg) throw errorOrg;
  if (errorUser) throw errorUser;
  if (connectionError) throw connectionError;
  if (!doc.data()) return null;

  const { info } = doc.data();

  const connected =
    (connection && connection.docs && connection.docs.length > 0) ||
    user.claims.admin === true;

  const fullName = connected
    ? `${info.firstName} ${info.lastName}`
    : 'Connect with employer to see full details';
  
  console.log("docOrg", docOrg);

  const hasData = docOrg && docOrg.data();

  const { info: orgInfo, officeAddress, type } = hasData ? docOrg.data() : {};
  
  const hasAddress = officeAddress != undefined;
  const hasOrg = orgInfo != undefined;

  const { address } = hasAddress ? officeAddress.fromOrg ? orgInfo : officeAddress : {};

  return (
    <LayoutPage className="employer-detail-page">
      <LayoutPage.Container className="wrapper">
        <header className="employer-detail-header">
          <Avatar src={info.photoURL} size={150} />
          <RatingAverage role="isEmployer" />
          <h1>{fullName}</h1>
          <div className="employer-detail-actions">
            {connected ? (
              <>
                <Button
                  href={`tel:${info.mobilePhone}`}
                  icon={<PhoneOutlined />}
                >
                  {info.mobilePhone}
                </Button>
                <Button href={`mailto:${info.email}`} icon={<MailOutlined />}>
                  {info.email}
                </Button>
              </>
            ) : null}
          </div>
        </header>

        {connected && hasOrg && hasAddress ? (
          <section className="employer-detail-info">
            <Divider />
            <h2>{orgInfo.name}</h2>
            <p>
              <strong>Type:</strong>
              <br />
              {getLabel(type.type, orgTypes)}
              <br />
              <br />
              <strong>Sector:</strong>
              <br />
              {getLabel(type.service, sectors)}
              <br />
              <br />
              <strong>Address:</strong>
              <br />
              {address.houseNo} {address.address01}
              <br />
              {address.country}, {address.postCode}
              <br />
              {address.town}
            </p>
          </section>
        ) : null}
      </LayoutPage.Container>
    </LayoutPage>
  );
};

export default EmployerDetail;
